export default __webpack_public_path__ + "static/media/plbg.1b885bd4.jpg";